import { render } from "./detail-external-comments.vue?vue&type=template&id=566797d2&scoped=true&ts=true"
import script from "./detail-external-comments.vue?vue&type=script&lang=ts"
export * from "./detail-external-comments.vue?vue&type=script&lang=ts"

import "./detail-external-comments.vue?vue&type=style&index=0&id=566797d2&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566797d2"]])

export default __exports__